import {
  AgreementType,
  ApplicationProductTypeEnum,
  Query,
} from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import GetAgreements from 'services/graphql/queries/GetAgreements';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

const splitStringToArray = (input: string): string[] => {
  return input?.split(',');
};

const useLegalAgreements = (agreementTypesCommonString: string) => {
  const router = useRouter();
  const agreementTypes = splitStringToArray(agreementTypesCommonString);

  const [
    { data: agreementsDetails, fetching: loading, error },
    refetchAgreements,
  ] = useQuery<Query>({
    query: GetAgreements,
    requestPolicy: 'cache-and-network',
    variables: {
      types: agreementTypes || [
        ApplicationProductTypeEnum.Savings,
        ApplicationProductTypeEnum.Checking,
        ApplicationProductTypeEnum.Advance,
        ApplicationProductTypeEnum.PersonalLoan,
        ApplicationProductTypeEnum.AdvanceV2,
        ApplicationProductTypeEnum.PartnerCashback,
        ApplicationProductTypeEnum.ChargeCard,
        ApplicationProductTypeEnum.CreditMonitoring,
        ApplicationProductTypeEnum.LineOfCredit,
        ApplicationProductTypeEnum.PayOverTime,
      ],
    },
  });

  const refresh = () => {
    refetchAgreements({ requestPolicy: 'network-only' });
  };
  const cancel = () => {
    router.back();
  };

  const agreementsListDetails = agreementsDetails?.agreements
    ?.filter((agreement) => agreement.type !== AgreementType.Ecbsv)
    .filter((agreement) => agreement?.resource?.pdfDocument?.url);

  const { defaultTitle, defaultMessage, retryButtonTitle, cancelButtonTitle } =
    useDefaultErrorStrings();

  const responseError = useFormattedCombinedError(error);

  const buttons = {
    primaryButton: {
      title: retryButtonTitle,
      onPress: refresh,
    },
    secondaryButton: {
      title: cancelButtonTitle,
      onPress: cancel,
    },
  };

  const errorModel = error
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: responseError?.title ?? defaultTitle,
        messageBody: responseError?.message ?? defaultMessage,
        ...buttons,
      }
    : null;

  return {
    agreementsListDetails,
    errorModel,
    loading,
    refresh,
  };
};

export default useLegalAgreements;
